const uberV2 = {
  voucherDueDateTitle: 'Tanggal jatuh tempo',
};

module.exports = uberV2;
